import { useContext } from "react";
import styles from "./styles.module.css";
import AvailableSvg from "images/svg/available.svg";
import NotPaidSvg from "images/svg/NotPaid.svg";
import DineInSvg from "images/svg/DineIn.svg";
import ShopContext from "context/ShopContext";
import { roundOff } from "helpers/NumberFormatHelper";
import { TABLE_STATUS } from "const";

function TableCard({ table, getStatusClass, onClick, isSelected, isSelectionMode }) {
  const { selectedShop } = useContext(ShopContext);

  const status = table.status || TABLE_STATUS.AVAILABLE;

  const renderStatusImage = (status) => {
    switch (status) {
      case TABLE_STATUS.AVAILABLE:
        return <img src={AvailableSvg} alt={TABLE_STATUS.AVAILABLE} className={styles.statusImg} />;
      case TABLE_STATUS.NOT_PAID:
        return <img src={NotPaidSvg} alt={TABLE_STATUS.NOT_PAID} className={styles.statusImg} />;
      case TABLE_STATUS.DINE_IN:
        return <img src={DineInSvg} alt={TABLE_STATUS.DINE_IN} className={styles.statusImg} />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`${styles.tableCard} ${getStatusClass(status)} ${isSelected ? styles.selectedCard : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {isSelectionMode && (
        <div className={styles.selectionOverlay}>
          <input type="checkbox" checked={isSelected} readOnly className={styles.checkbox} />
        </div>
      )}
      <div className={styles.statusRibbon}>{status}</div>
      <div className={styles.nameSection}>
        <h4 className={styles.tableTitle}>{table.name}</h4>
        <p className={styles.areaName}>{table.area?.name}</p>
      </div>
      <div className={styles.amountSection}>
        <div className={styles.amount}>
          <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
          {roundOff(table.amount ?? 0)}
        </div>
        <div className={styles.items}>
          {table.itemsCount || 0} {table.itemsCount === 1 ? "Item" : "Items"}
        </div>
        {table.sales?.length > 1 && <span className={styles.orderCountBadge}>{table?.sales?.length} Orders</span>}
        {table?.chairs?.length > 0 && <span className={styles.chairCountBadge}>{table?.chairs.length} Chairs</span>}
      </div>
      <div className={styles.imgSection}>{renderStatusImage(status)}</div>
    </div>
  );
}

export default TableCard;
